<template>
  <div class="target">CURRENT CORE TARGET: --------- DEADLINE: XX/XX/XXXX</div>
</template>

<script>
export default {
  name: "CurrentTarget",
};
</script>

<style scoped>
.target {
  width: 100%;
  text-align: center;
}
</style>